import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardHeader,CardBlock, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import { ajaxWrapperGet } from '../../../utils/deviceAPI';
import LoadingIndicator from '../../../utils/LoadingIndicator'
import {Bar, Line, ChartData} from "react-chartjs-2";

import Generator from '../GeneratorSchema/Generator'
import moment from 'moment'

import Anime from 'react-anime';
import DeviceOffline from '../DeviceMessages/DeviceOffline';
//google maps




class AnnunciatorSystem extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [
            {

                initializer: 0,
            },
            {
                initializer: 0,
            }

        ],
            loading: true

        };
    }
    componentDidMount() {
        this.tick();
        this.timerID = setInterval(
            () => this.tick(),
            5000
        );
    }
    componentWillUnmount(){
        clearInterval(this.timerID);
    }

    tick() {
        ajaxWrapperGet('/api/deviceAlarms').then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }


    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        if (this.props.devicestatus === 0) {
            return (
                <DeviceOffline/>
            )
        }
        const { data } = this.state;
        const generatorSelected = this.props.generator;
        const utilitySelected = this.props.utility;
        console.log(data);

        //console.log(data);
        if (this.props.systemtype === 'system') {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" lg="12">
                            <Table hover responsive className="table-outline d-sm-table bg-white">
                                <thead className="thead-default">
                                <tr>
                                    <th className="text-center" colSpan="2" >System Alarms</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.systemAlarms.map(function(alarm,index){
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {alarm.status === 1 ? <Badge color="danger">Alarmed</Badge> : ''}
                                            </td>
                                            <td>
                                                {alarm.message}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            )
        }
        else if (this.props.systemtype === 'generator') {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" md= "6" lg="6" xl="3">
                            <Table hover responsive className="table-outline d-sm-table bg-white">
                                <thead className="thead-default">
                                <tr>
                                    <th className="text-center" colSpan="2" >Generator {generatorSelected} SD Alarms</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.generatorAlarms['generator' + generatorSelected].AlarmsShutdown1Alarms.map(function(alarm,index){
                                    return (
                                        <tr key={index} >
                                            <td>
                                                {alarm.status === 1 ? <Badge color="danger">Alarmed</Badge> : ''}
                                            </td>
                                            <td>
                                                {alarm.message}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </Col>

                        <Col xs="12" md= "6" lg="6" xl="3">
                            <Table hover responsive className="table-outline d-sm-table bg-white">
                                <thead className="thead-default">
                                <tr>
                                    <th className="text-center" colSpan="2" >Generator {generatorSelected} SD Alarms</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.generatorAlarms['generator' + generatorSelected].AlarmsShutdown2Alarms.map(function(alarm,index){
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {alarm.status === 1 ? <Badge color="danger">Alarmed</Badge> : ''}
                                            </td>
                                            <td>
                                                {alarm.message}
                                            </td>
                                        </tr>
                                    );
                                })}

                                </tbody>
                            </Table>
                        </Col>

                        <Col xs="12" md= "6" lg="6" xl="3">
                            <Table hover responsive className="table-outline d-sm-table bg-white">
                                <thead className="thead-default">
                                <tr>
                                    <th className="text-center" colSpan="2" >Generator {generatorSelected} Pre Alarms</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.generatorAlarms['generator' + generatorSelected].AlarmsPre1Alarms.map(function(alarm,index){
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {alarm.status === 1 ? <Badge color="warning">Alarmed</Badge> : ''}
                                            </td>
                                            <td>
                                                {alarm.message}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </Col>

                        <Col xs="12" md= "6" lg="6" xl="3">
                            <Table hover responsive className="table-outline d-sm-table bg-white">
                                <thead className="thead-default">
                                <tr>
                                    <th className="text-center" colSpan="2" >Generator {generatorSelected} Pre Alarms</th>
                                </tr>
                                </thead>
                                <tbody>

                                {data.generatorAlarms['generator' + generatorSelected].AlarmsPre2Alarms.map(function(alarm,index){
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {alarm.status === 1 ? <Badge color="warning">Alarmed</Badge> : ''}
                                            </td>
                                            <td>
                                                {alarm.message}
                                            </td>
                                        </tr>
                                    );
                                })}

                                </tbody>
                            </Table>
                        </Col>


                    </Row>
                </div>
            )
        }
        else if (this.props.systemtype === 'utility') {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" lg="12">
                            <Table hover responsive className="table-outline d-sm-table bg-white">
                                <thead className="thead-default">
                                <tr>
                                    <th className="text-center" colSpan="2" >Utility {utilitySelected} Alarms</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.utility['utility' + utilitySelected].alarms.map(function(alarm,index){
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {alarm.status === 1 ? <Badge color="danger">Alarmed</Badge> : ''}
                                            </td>
                                            <td>
                                                {alarm.message}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            )
        }

    }
}

export default AnnunciatorSystem;



// WEBPACK FOOTER //
// ./src/views/site/Annunciator/System.js